import { NamingTypeEnum } from '../auth';

export class NamingTypeService {
  public static getName(
    type: NamingTypeEnum,
    name: string,
    numberValue: string
  ): string {
    if (numberValue) {
      if (type === NamingTypeEnum.OnlyNumber) {
        return `${numberValue} ${name}`;
      }
      if (type === NamingTypeEnum.NameWithNumber) {
        return `${name} (${numberValue})`;
      }
    }
    return name;
  }
}
